import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jsdAppDiscovery: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.integrations.jsd-app-discovery',
		defaultMessage: 'Explore apps',
		description: 'Settings navigation menu link for a service project',
	},
	devtools: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.integrations.devtools',
		defaultMessage: 'Development tools',
		description: 'Settings navigation menu link to the development tools page',
	},
	itemBack: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.integrations.item-back',
		defaultMessage: 'Back to project settings',
		description: '"Back" menu item.',
	},
});
